<template>
    <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
            <thead>
                <tr>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        {{ $t('form.date.label') }}
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                        v-for="step in questions" :key="step.id">
                        <span v-html="step.title"></span>
                    </th>
                    <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end" v-if="env === 'kareena'">
                        {{ $t('feature.surveys.role') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="response in responses" :key="response.id">
                    <td class="shadow-none lh-1 fw-medium text-primary">
                        {{ YYYYMMDD(response.date) }}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end" v-for="step in questions"
                        :key="`asnwer-${step.id}`">
                        {{ $s.getAnswer(step.id!, response) }}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end" v-if="env === 'kareena'">
                        {{ $t(`feature.roles.$type.${response.created_by_role ?? role.patient}`) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script lang="ts">
import API from '@/services/api/api.service';
import { Survey, SurveyResponse, SurveyStep, SurveyStepRepresentationType, SurveyStepType } from '@/utils/models/survey.model';
import DateFormatUtils from "@/utils/methods/date_formats";
import { PropType, defineComponent } from 'vue';
import { CLIENT, Environment } from '@/utils/const/env';
import { SurveyUtils } from '@/utils/methods/survey_utils';
import { Role } from '@/utils/models/user.model';

export default defineComponent({
    name: 'SurveyTable',
    props: {
        survey: {
            type: Object as PropType<Survey>,
            required: true
        },
        responses: {
            type: Object as PropType<SurveyResponse[]>,
            required: false
        }
    },
    data: function () {
        return {
            responses_data: undefined,
            patient_id: this.$route.params.id,
        } as {
            responses_data?: SurveyResponse[];
            patient_id: string;
        }
    },
    computed: {
        instances(): SurveyResponse[] | undefined {
            return this.responses ?? this.responses_data;
        },
        role() {
            return Role;
        },
        stepType() { return SurveyStepType },
        env(): Environment { return CLIENT },
        questions(): SurveyStep[] {
            return this.survey.steps.filter((step) => step.type !== SurveyStepType.description && step.type !== SurveyStepType.finalize)
        },
        YYYYMMDD() {
            return DateFormatUtils.YYYYMMDD;
        },
        $s(): SurveyUtils {
            return new SurveyUtils(this.survey, this.responses ?? []);
        }
    },
    methods: {
        getSurveyAnswers() {
            this.responses_data = undefined;
            API.getSurveyAnswers({ survey_id: this.survey.id, patient_id: this.patient_id }).then((response) => {
                this.responses_data = response.data.data ?? [];
            }).catch((error) => {
                console.error(error);
                this.responses_data = [];
            });

        },
        formatTime(date: Date) {
            return DateFormatUtils.HHmm(date);
        }
    },
})

</script>
